// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
/*
const useStyles = makeStyles((theme) => ({
	udisplay: {
		backgroundColor: 'black',
		padding: 5,
		color: '#ffaa00',
		height: 55,
		boxSizing:'border-box',
		width : 70
	},
}));
*/


export default function Display(props) {
  	//const classes = useStyles();
  	const {width, height, displayState, pixel_map, scale, splitVertical, borderSize} = props;
	//const [msgid, setMsgid] = React.useState(0);
	//const [imgpath, setImgpath] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/');
	//const [size, setSize] = React.useState([30, 18]);
	//const [scaling, setScaling] = React.useState(2);
	//const [isOn, setIsOn] = React.useState(true);
	//const [flashing, setFlashing] = React.useState(false);
	//const [img, setImg] = React.useState('/needs/vspeedOnline/sign-data/pixel_messages/0.gif');
	//const [pixels, setPixels] = React.useState('000011100100000011100100010000,000100010100000100010100010000,000100000100000100010101010000,000100000100000100010101010000,000011100100000100010101010000,000000010100000100010101010000,000000010100000100010101010000,000100010100000100010101010000,000011100111110011100011100000,000111100011100100010100010000,000100010100010100010100010000,000100010100010101010110010000,000100010100010101010101010000,000100010100010101010100110000,000100010100010101010100010000,000100010100010101010100010000,000100010100010101010100010000,000111100011100011100100010000,');
	//standard is 30 x 18
	
	
	
	
	
	const renderStyle = () => {
		//console.log(classes.udisplay);
		let outstyle = {
			'background-color' : '#000000',
			//'background-image' : 'url('+img+')',
			'background-size' : 'contain',
			'background-repeat' : 'no-repeat',
			'background-position' : 'center',
			'width':width * scale,
			'height':((splitVertical ? splitVertical : 0) + height) * scale,
			'border': (borderSize ? borderSize : '10')+'px solid black',
			boxSizing:'content-box',
		}
		if(displayState === 'on'){
			outstyle.backgroundBlendMode = 'normal';
		} else {
			outstyle.backgroundBlendMode = 'darken'
		}
		return outstyle;
		
	}
	
	const renderPath = (map) => {
		var path = "";
		map.forEach((pix, n) => {
			if(parseInt(pix) === 1){
				path+='M'+(n%width*scale)+' '+(Math.floor(n/width)*scale)+
					'h'+Math.ceil(scale / 2)+' '+Math.ceil(scale / 2)+
					'v'+Math.ceil(scale / 2)+' '+Math.ceil(scale / 2)+
					'h-'+Math.ceil(scale / 2)+' -'+Math.ceil(scale / 2)+'Z';
			}
		});
		return path;
	}
	const renderDisplayImage = () => {
		if(displayState === 'on'){
			//if(pixels){
				
				//.slice(0, size[1])
				//substr(0, size[0])
				var map = Array.from(
					pixel_map.split(',').filter(i=>i).slice(0, height), 
					line => line.substr(0, width).split(''));
				if(splitVertical){
					map.splice(height/2, 0, '0'.repeat(width*splitVertical).split(''));
				}
				//console.log(map);
				return (
					<svg 
						width={width*scale} height={(height + (splitVertical ? splitVertical : 0)) * scale}>
						<rect x={0} y={0} width={width*scale} height={(height +(splitVertical ? splitVertical : 0)) * scale} fill="#000" stroke="none"/>
						<path d={renderPath(map.flat())} fill="#f80" stroke="none"/>
					</svg>
				);
				/*
				return (
					<svg width={size[0]*scale} height={ (size[1] + (splitVertical ? splitVertical : 0)) * scale}>
						{map.flat().map(renderPixel)}
					</svg>
				);
				*/
			//} else {
			//	return "";
			//}
		} else {
			return "";
		}
	}
	
	

  return (
	  <div style={renderStyle()}>
	  	{renderDisplayImage()}
	  </div>
  );
}
